import { NgModule } from '@angular/core';
import { SharedModule } from 'app/shared/shared.module';
import { MapPickerModule } from '../map-picker/map-picker.module';
import { ContactInfoComponent } from './contact-info.component';

@NgModule({
    declarations: [
        ContactInfoComponent
    ],
    imports: [
        SharedModule,
        MapPickerModule
    ],
    exports: [
        ContactInfoComponent
    ]
})
export class ContactInfoFormModule { }
